export default __webpack_public_path__ + "static/alexandre-11713348783fb9bc8f11984e027f153b.jpg";